<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer008">
<p class="_ded" id="_idParaDest-3">To Blue Moon Circle, past and present, and to my readers because y’all rock. Thanks for asking for this book.</p>
<div class="x15">
<p class="center"><img alt="black cat" class="i100" src="image/2.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?422ed70f